import React from 'react';
import { BoardSelectionOverlay } from '../boardSelectionOverlay.js';

export const BoardMapDraftLayer = ({
  selectionBox,
}) => {
  const hasSelectionBox =
    selectionBox &&
    Number.isFinite(selectionBox.x) &&
    Number.isFinite(selectionBox.y) &&
    Number.isFinite(selectionBox.w) &&
    Number.isFinite(selectionBox.h) &&
    selectionBox.w > 0 &&
    selectionBox.h > 0;

  if (!hasSelectionBox) {
    return null;
  }

  return (
    <>
      <BoardSelectionOverlay rect={hasSelectionBox ? selectionBox : null} />
    </>
  );
};
